module.exports = __webpack_public_path__ + "static/media/zorkington.3c20967d.png";